import { render, staticRenderFns } from "./ArrowBtn.vue?vue&type=template&id=11722ec8&scoped=true&lang=pug"
import script from "./ArrowBtn.vue?vue&type=script&lang=js"
export * from "./ArrowBtn.vue?vue&type=script&lang=js"
import style0 from "./ArrowBtn.vue?vue&type=style&index=0&id=11722ec8&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11722ec8",
  null
  
)

export default component.exports